import { PropsWithChildren, ReactNode } from 'react';

import { SidebarSectionMui as SidebarSection } from '@spotify/confidence-core-react';

import { CommentZoneContext } from '../../contexts';
import { CommentZone } from '../CommentZone';

export type SidebarSectionWithCommentZonesProps = {
  title: ReactNode;
  zoneContext?: string;
  action?: ReactNode;
  description?: ReactNode;
};

export const SidebarSectionWithCommentZones = ({
  title,
  zoneContext,
  children,
  action,
  description,
}: PropsWithChildren<SidebarSectionWithCommentZonesProps>) => {
  return (
    <SidebarSection.Root data-testid={`sidebar-section-${title}`}>
      <CommentZoneContext zone={`${zoneContext}-sidebar`}>
        <SidebarSection.Header>
          <SidebarSection.Title>
            <CommentZone id="section-title" component="span">
              {title}
            </CommentZone>
          </SidebarSection.Title>

          {action && <SidebarSection.Action>{action}</SidebarSection.Action>}

          {description && (
            <SidebarSection.Description>
              {description}
            </SidebarSection.Description>
          )}
        </SidebarSection.Header>
        <SidebarSection.Content>{children}</SidebarSection.Content>
      </CommentZoneContext>
    </SidebarSection.Root>
  );
};
